<template>
  <div>
    <div class="user_module">
      <div class="module_head2">
        <div>
          账户基本信息
        </div>
      </div>
      <div class="d_content">
        <table border="0" cellspacing="0" cellpadding="0" class="table">
          <tr>
            <td class="td_bg" width="200px">用户名</td>
            <td class="td_pos">{{ userInfo.username }}<span v-if="false" class="td_s_btn"
                                                                 @click="dialogVisibleUname = true">修改</span></td>
            <!--<td class="td_bg " rowspan="4" width="144px">
              <div class="text_center">
                <div><img :src="imgUrl+'headimage2.png'"/></div>
                <div class="btn_outer uset" style="margin-bottom: 8px;">
                  <el-button type="primary" plain @click="dialogVisibleModifyPW = true"><i
                    class="cloudicon ci_lock"></i>&nbsp;修改密码
                  </el-button>
                </div>
                <div class="btn_outer uset">
                  <el-button type="primary" plain  @click="logout"><i class="cloudicon ci_mapback"></i>&nbsp;&nbsp;退出登录</el-button>
                </div>
              </div>
            </td>-->
          </tr>


          <tr>
            <td class="td_bg" width="200px">使用人姓名</td>
            <td class="td_pos">{{ userInfo.user_nickname }}<span  class="td_s_btn" @click="showSubmitUname">修改</span></td>
          </tr>


          <tr>
            <td class="td_bg">用户手机号码</td>
            <td class="td_pos">{{ userInfo.mobile }}<span class="td_s_btn" @click="showLoginDiog">更换手机号</span>
            </td>
          </tr>
          <tr>
            <td class="td_bg">用户邮箱</td>
            <td class="td_pos">{{ userInfo.user_email }}<span class="td_s_btn"
                                                              @click="dialogVisibleMail = true">修改邮箱地址</span></td>
          </tr>
          <tr>
            <td class="td_bg">上次登录时间</td>
            <td>{{ userInfo.last_login_time }}</td>
          </tr>
        </table>
      </div>


      <div class="module_head2 mt">
        <div>
          企业基本信息
        </div>
        <div class="btn_outer">
          <el-button type="primary" plain @click="dialogVisibleQyInfo = true"><i class="cloudicon ci_modify"></i> 修改
          </el-button>
        </div>

      </div>
      <div class="d_content">
        <table border="0" cellspacing="0" cellpadding="0" class="table">
          <tr>
            <td class="td_bg" width="260px">单位名称</td>
            <td v-text="corpInfo.cname"></td>
          </tr>
          <tr>
            <td class="td_bg">社会统一信用代码或组织机构代码</td>
            <td v-text="corpInfo.creditcode"></td>
          </tr>
          <tr>
            <td class="td_bg">单位性质</td>
            <td v-text="corpInfo.qyxz_name"></td>
          </tr>
          <tr>
            <td class="td_bg">注册资金</td>
            <td v-text="corpInfo.registcapi"></td>
          </tr>
          <tr>
            <td class="td_bg">注册地址</td>
            <td v-text="corpInfo.address"></td>
          </tr>
          <tr>
            <td class="td_bg">实际经营地址</td>
            <td v-text="corpInfo.jyd_addr"></td>
          </tr>
          <tr>
            <td class="td_bg">法人代表</td>
            <td v-text="corpInfo.opername"></td>
          </tr>
          <tr>
            <td class="td_bg">企业负责人手机号码</td>
            <td v-text="corpInfo.phone"></td>
          </tr>
          <tr>
            <td class="td_bg">企业负责人邮箱</td>
            <td v-text="corpInfo.email"></td>
          </tr>
        </table>
      </div>
      <div class="module_head2 mt">
        <div>
          企业标签信息
        </div>
        <div class="btn_outer">
          <el-button type="primary" plain @click="dialogVisibleLabel = true"><i class="cloudicon ci_modify"></i> 修改
          </el-button>
        </div>

      </div>

      <div class="d_content">
        <table border="0" cellspacing="0" cellpadding="0" class="table">
          <tr>
            <td class="td_bg" width="260px">企业规模</td>
            <td v-text="corpSizeStr"></td>
          </tr>
          <tr>
            <td class="td_bg">企业所属行业</td>
            <td v-text="corpTypeStr"></td>
          </tr>
          <tr>
            <td class="td_bg">关注申报类型</td>
            <td v-text="policyStr"></td>
          </tr>
        </table>
      </div>
    </div>

    <el-dialog
      title="修改使用人姓名"
      :visible.sync="dialogVisibleUname"
      width="30%">

      <div class="change_dialog">
        <div>
          <el-input placeholder="请输入使用人姓名" v-model="newUname"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitUname">确 定</el-button>
		    <el-button @click="dialogVisibleUname = false">取 消</el-button>
		  </span>
    </el-dialog>

    <el-dialog
      title="修改手机号"
      :visible.sync="dialogVisible1"
      width="30%">

      <div class="change_dialog">
        <div class="h">
          <div>修改手机号码</div>
          <div><span class="num">1</span>/2 请输入登录密码</div>
        </div>
        <div>
          <el-input placeholder="请输入登录密码" type="password" v-model="loginPw"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="nextstep">下一步</el-button>
		    <el-button @click="dialogVisible1 = false">取 消</el-button>
		  </span>
    </el-dialog>

    <el-dialog
      title="修改手机号"
      :visible.sync="dialogVisible2"
      width="30%">

      <div class="change_dialog">
        <div class="h">
          <div>修改手机号码</div>
          <div><span class="num">2</span>/2 手机号码更换后，将使用新手机号码接收推送信息！</div>
        </div>
        <div class="d_content">
          <table border="0" cellspacing="0" cellpadding="0" class="table">
            <tr>
              <td class="td_bg">新手机号码</td>
              <td>
                <el-input v-model="newphone" placeholder="请输入您要更换的新号码"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">验证码</td>
              <td>
                <div class="td_pos">
                  <el-input v-model="yzm" placeholder="请输入短信验证码"></el-input>
                  <div class="btn_outer pos_ab">
                    <el-button type="primary" plain @click="sendSms">发送验证码</el-button>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="changeMobile">确定</el-button>
		    <el-button @click="dialogVisible2 = false">取 消</el-button>
		  </span>
    </el-dialog>

    <el-dialog
      title="修改邮箱地址"
      :visible.sync="dialogVisibleMail"
      width="30%">

      <div class="change_dialog">
        <div>
          <el-input placeholder="请输入邮箱" v-model="newMail"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitMail">确 定</el-button>
		    <el-button @click="dialogVisibleMail = false">取 消</el-button>
		  </span>
    </el-dialog>


    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisibleModifyPW"
      width="30%">

      <div class="change_dialog">
        <div>
          <el-input placeholder="请输入旧密码" v-model="oldpw" show-password></el-input>
        </div>
        <div style="margin: 20px 0;">
          <el-input placeholder="请输入新密码" v-model="newpw" show-password></el-input>
        </div>
        <div>
          <el-input placeholder="请再次输入新密码" v-model="newpw2" show-password></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitModifyPW">确 定</el-button>
		    <el-button @click="dialogVisibleModifyPW = false">取 消</el-button>
		  </span>
    </el-dialog>


    <el-dialog
      title="修改企业基本信息"
      :visible.sync="dialogVisibleQyInfo"
      width="800px">
      <el-form :model="corpInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div class="d_content">
          <table border="0" cellspacing="0" cellpadding="0" class="table">
            <tr>
              <td class="td_bg" width="260px">单位名称 <span style="color: red;font-weight: bold">*</span></td>
              <td>
                <el-form-item prop="cname">
                  <el-input v-model="corpInfo.cname"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="td_bg">社会统一信用代码或组织机构代码</td>
              <td>
                <el-input v-text="corpInfo.creditcode" readonly></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">单位性质</td>
              <td>
                <el-select v-model="corpInfo.qyxz" placeholder="请选择" style="width:100%">
                  <el-option
                    v-for="item in qyxzOpts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="td_bg">注册资金</td>
              <td>
                <el-input v-model="corpInfo.registcapi"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">注册地址</td>
              <td>
                <el-input v-model="corpInfo.address"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">实际经营地址</td>
              <td>
                <el-input v-model="corpInfo.jyd_addr"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">法人代表</td>
              <td>
                <el-input v-model="corpInfo.opername"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">企业负责人手机号码</td>
              <td>
                <el-input v-model="corpInfo.phone" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">企业负责人邮箱</td>
              <td>
                <el-form-item prop="email">
                  <el-input v-model="corpInfo.email"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="onSubmitQyInfo">确 定</el-button>
		    <el-button @click="dialogVisibleQyInfo = false">取 消</el-button>
		  </span>
    </el-dialog>


    <el-dialog
      title="修改企业标签"
      :visible.sync="dialogVisibleLabel"
      width="40%">

      <div class="change_dialog">
        <div class="h">
          <div>修改企业标签</div>
          <div>设置您的企业标签，以下选中标签将作为接受推送信息的标签</div>
        </div>
        <div class="checked_label_outer">
          <div class="btn_outer">
            <el-button plain v-for="(item,index) in checkedList" :key="index" @click="deletLabel(item)">
              {{ item.name }}<i class="cloudicon ci_unvalid"></i></el-button>
          </div>
        </div>
        <div class="d_content">
          <table border="0" cellspacing="0" cellpadding="0" class="table label_table">
            <tr>
              <td class="td_bg" width="120px">企业规模</td>
              <td>
                <el-radio-group v-model="checkList[0]">
                  <el-radio :label="item[0]" v-for="(item,index) in corpSizeList" :key="item[0]+'cl'">{{ item[1] }}
                  </el-radio>
                </el-radio-group>
              </td>
            </tr>
            <tr>
              <td class="td_bg">企业类型</td>
              <td>
                <el-checkbox-group v-model="checkList2">
                  <el-checkbox :label="item[0]" v-for="(item,index) in corpTypeList" :key="item[0]+'cl2'">
                    {{ item[1] }}
                  </el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
            <tr>
              <td class="td_bg">关注申报类型</td>
              <td>
                <el-checkbox-group v-model="checkList3">
                  <el-checkbox :label="item[0]" v-for="(item,index) in policyList" :key="item[0]+'cl3'">{{ item[1] }}
                  </el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="submitTag">确定</el-button>
		    <el-button @click="dialogVisibleLabel = false">取 消</el-button>
		  </span>
    </el-dialog>
  </div>
</template>


<script>
import Qs from 'qs';

export default {
  name: 'userset',
  inject: ['reload'],
  created() {
    this.getsysInfo();
    this.getCorpInfo();
    this.reflashInfos();
  },

  data() {
    return {
      dialogVisibleUname: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisibleMail: false,
      dialogVisibleModifyPW: false,
      dialogVisibleQyInfo: false,
      dialogVisibleLabel: false,
      checkList: [],
      checkList2: [],
      checkList3: [],
      newUname: '',
      loginPw: '',
      newphone: '',
      yzm: '',
      newMail: '',
      oldpw: '',
      newpw: '',
      newpw2: '',
      userInfo: {},
      corpInfo: {},
      corpTag: {},
      corpSizeStr: '',
      corpTypeStr: '',
      policyStr: '',
      corpSizeList: [],
      policyList: [],
      corpTypeList: [],
      qyxzOpts: [
        {value: 1, label: '内资'},
        {value: 2, label: '外资'},
        {value: 3, label: '港澳台'}
      ],
      rules: {
        cname: [
          {type: 'string', required: true, message: '请输入企业名称', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ]
      }

    }
  },
  computed: {
    checkedList: function () {
      let that = this;

      let list01 = [];
      that.checkList.forEach(item => {
        that.corpSizeList.forEach(function (t, i, a) {
          if (item == t[0]) {
            list01.push({tag: 1, name: t[1], num: item})
          }
        })
      });
      let list02 = [];
      that.checkList2.forEach(item => {
        that.corpTypeList.forEach(function (t, i, a) {
          if (item == t[0]) {
            list02.push({tag: 2, name: t[1], num: item})
          }
        })
      });

      let list03 = [];
      that.checkList3.forEach(item => {
        that.policyList.forEach(function (t, i, a) {
          if (item == t[0]) {
            list03.push({tag: 3, name: t[1], num: item})
          }
        })
      });

      return list01.concat(list02, list03)
    }
  },
  methods: {
    getsysInfo() {
      let sysinfo = window.localStorage.getItem("gyzhqy_sys_info");
      sysinfo = JSON.parse(sysinfo)
      this.corpSizeList = sysinfo.corpsize;
      this.corpTypeList = sysinfo.corp_type;
      this.policyList = sysinfo.policy;
    },
    async getCorpInfo() {
      let res01 = await this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo');
      window.localStorage.setItem("gyzhqy_corp_info", JSON.stringify(res01.data.data))
      let res02 = await this.$ajax.get(this.bUrl + 'api/portal/user/tags');
      window.localStorage.setItem("gyzhqy_corp_tag", JSON.stringify(res02.data.data))
    },

    async submitTag() {
      let data = {
        corpsize: this.checkList.join(","),
        corp_type: this.checkList2.join(","),
        policy: this.checkList3.join(',')
      };
      let res = await this.$ajax.post(this.bUrl + 'api/portal/user/set', data);
      await this.getCorpInfo();
      this.reflashInfos();
      this.dialogVisibleLabel = false
      this.reload()
    },

    showLoginDiog() {
      this.loginPw = '';
      this.dialogVisible1 = true
    },


    async changeMobile() {
      let data = {
        password: this.loginPw,
        mobile: this.newphone,
        verification_code: this.yzm
      }
      let res = await this.$ajax.post(this.bUrl + 'api/user/profile/changemobile', data);
      if (res.data.code === 200) {
        this.$message.success(res.data.msg);
        this.dialogVisible2 = false;

        if (JSON.parse(window.localStorage.getItem("gyzhqy_user_info")) != null) {
          this.userInfo = JSON.parse(window.localStorage.getItem("gyzhqy_user_info"));
          this.userInfo.mobile = this.newphone;
          window.localStorage.setItem("gyzhqy_user_info", JSON.stringify(this.userInfo));
        }

        this.reload()
      } else {
        this.$message.error(res.data.msg);
      }
    },
    async sendSms() {
      var data = Qs.stringify({'username': this.newphone});
      let res = await this.$ajax.post(this.bUrl + 'api/home/index/sendcode', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
      if (res.data.code === 200) {
        this.$message.success(res.data.msg);
      } else {
        this.$message.error(res.data.msg);
      }
    },

    logout() {
      window.localStorage.setItem('gyzhqy_token', null);
      window.localStorage.setItem('gyzhqy_corp_info', null);
      window.localStorage.setItem('gyzhqy_corp_tag', null);
      this.$store.commit('mcn', '登录');
      this.$router.push({path: '/'})
    },

    showModifyPWDialog(){
      this.oldpw='';
      this.newpw='';
      this.confirm_password='';
      this.dialogVisibleModifyPW = true;
    },


    async submitModifyPW() {
    //  if(this.oldpw==='') this.$message.error(res.data.msg);
      if(this.newpw==='') {
        this.$message.error("新密码不能为空");
        return;
      }
      if(this.newpw!==this.newpw2){
        this.$message.error("两次输入密码不一致");
        return;
      }
      let data = {
        old_password: this.oldpw,
        password: this.newpw,
        confirm_password: this.newpw2
      }
      let res = await this.$ajax.post(this.bUrl + 'api/user/profile/changePassword', data);
      if (res.data.code == 200) {
        this.$message.success(res.data.msg);
        this.dialogVisibleModifyPW = false
        this.reload()
      } else {
        this.$message.error(res.data.msg);
      }
    },

    reflashInfos() {
      let that = this;
      if (JSON.parse(window.localStorage.getItem("gyzhqy_corp_info")) != null) {
        this.corpInfo = JSON.parse(window.localStorage.getItem("gyzhqy_corp_info"));
      }
      if (JSON.parse(window.localStorage.getItem("gyzhqy_user_info")) != null) {
        this.userInfo = JSON.parse(window.localStorage.getItem("gyzhqy_user_info"));
      }
      if (JSON.parse(window.localStorage.getItem("gyzhqy_corp_tag")) != null) {
        this.corpTag = JSON.parse(window.localStorage.getItem("gyzhqy_corp_tag"));
      }

      let res02 = this.$ajax.get(this.bUrl + 'api/portal/user/tags');

      let list01 = this.corpTag.corpsize;
      let list02 = this.corpTag.corp_type;
      let list03 = this.corpTag.policy;

      if (list01.length > 0) this.checkList = list01;
      if (list02.length > 0) this.checkList2 = list02;
      if (list03.length > 0) this.checkList3 = list03;

//		        that.corpSizeStr='';
      list01.map(item => {
        that.corpSizeList.forEach(function (t, i, a) {
          if (t[0] == item) {
            that.corpSizeStr = that.corpSizeStr + t[1] + '、'
          }
        })
      });

//		        that.corpTypeStr='';
      list02.map(item => {
        that.corpTypeList.forEach(function (t, i, a) {
          if (t[0] == item) {
            that.corpTypeStr = that.corpTypeStr + t[1] + '、'
          }
        })
      });

//		        that.policyStr='';
      list03.map(item => {
        that.policyList.forEach(function (t, i, a) {
          if (t[0] == item) {
            that.policyStr = that.policyStr + t[1] + '、'
          }
        })
      });

      that.corpSizeStr=that.corpSizeStr.substring(0,that.corpSizeStr.length-1)
      that.corpTypeStr=that.corpTypeStr.substring(0,that.corpTypeStr.length-1)
      that.policyStr=that.policyStr.substring(0,that.policyStr.length-1)

    },
    showSubmitUname() {
      this.newUname='';
      this.dialogVisibleUname = true;
    },
    async submitUname() {
      if(this.newUname===''){
        this.$message.error('使用人姓名不能为空');
        return false;
      }

      let res = await this.$ajax.post(this.bUrl + 'api/portal/user/nickname', {user_nickname: this.newUname});
      if (res.data.code === 200) {
        this.$message.success(res.data.msg)
        this.dialogVisibleUname = false
        if (JSON.parse(window.localStorage.getItem("gyzhqy_user_info")) != null) {
          this.userInfo = JSON.parse(window.localStorage.getItem("gyzhqy_user_info"));
          this.userInfo.user_nickname = this.newUname;
          window.localStorage.setItem("gyzhqy_user_info", JSON.stringify(this.userInfo));
        }
        this.reload();
      } else {
        this.$message.error(res.data.msg)
      }
    },

    async submitMail() {

      let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
      if (this.newMail === "") { //输入不能为空
        this.$message.error('请输入正确的邮箱');
        return false;
      } else if (!reg.test(this.newMail)) { //正则验证不通过，格式不对
        this.$message.error('请输入正确的邮箱');
        return false;
      }

      let res = await this.$ajax.post(this.bUrl + 'api/user/profile/bindingEmail', {email: this.newMail});
      if (res.data.code === 200) {
        this.$message.success(res.data.msg)
        this.dialogVisibleMail = false
        if (JSON.parse(window.localStorage.getItem("gyzhqy_user_info")) != null) {
          this.userInfo = JSON.parse(window.localStorage.getItem("gyzhqy_user_info"));
          this.userInfo.user_email = this.newMail;
          window.localStorage.setItem("gyzhqy_user_info", JSON.stringify(this.userInfo));
        }
        this.reload();
      } else {
        this.$message.error(res.data.msg)
      }
    },

    async onSubmitQyInfo() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.submitQyInfo()
        } else {
          setTimeout(() => {
            var isError = document.getElementsByClassName("is-error");
            var htmlInputElement = isError[0].querySelector('input');
            if (htmlInputElement) htmlInputElement.focus();

            var htmlAreaElement = isError[0].querySelector('textarea');
            if (htmlAreaElement) htmlAreaElement.focus();
          }, 100);
          return false;
        }
      });
    },


    async submitQyInfo() {
      let data = {};
      data.phone = this.corpInfo.phone;
      data.email = this.corpInfo.email;
      data.qyxz = this.corpInfo.qyxz;
      data.registcapi = this.corpInfo.registcapi;
      data.address = this.corpInfo.address;
      data.jyd_addr = this.corpInfo.jyd_addr;
      data.opername = this.corpInfo.opername;
      data.cname = this.corpInfo.cname;

      let res = await this.$ajax.post(this.bUrl + 'api/portal/user/editCorpInfo', data);
      if (res.data.code === 200) {
        this.dialogVisibleQyInfo = false;
        this.$message.success(res.data.msg);
        await this.getCorpInfo();
        this.reflashInfos();
        this.reload();
        //  await this.getCorpInfo();
        //  this.reflashInfos();
      } else {
        this.$message.error(res.data.msg)
      }

    },
    nextstep() {
      if (this.loginPw === '') {
        this.$message.error('请输入登录密码');
        return
      }
      this.dialogVisible1 = false;
      this.dialogVisible2 = true;
    },
    deletLabel(item) {
      /*
      this.del(this.checkList2,item)
      this.del(this.checkList3,item)*/
      if (item.tag === 1) {
        this.del(this.checkList, item.num)
      } else if (item.tag === 2) {
        this.del(this.checkList2, item.num)
      } else if (item.tag === 3) {
        this.del(this.checkList3, item.num);
      }
    },
    del(clArr, item) {
      clArr.forEach(function (t, i, arr) {
        if (item == t) {
          arr.splice(i, 1)
        }
      }, this)
    }
  }
}
</script>

<style scoped>
.user_module {
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  border: 1px solid #E1EAFA;
  margin-bottom: 20px;
}

.module_head2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  font-size: 18px;
  color: #143367;
}

.mt {
  margin-top: 44px;
}

.ci_modify {
  font-size: 24px;
}


.ci_lock {
  font-size: 24px;
}

.ci_mapback {
  font-size: 18px;
}

.change_dialog {

}

.change_dialog .h {
  text-align: center;
  line-height: 34px;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.change_dialog .num {
  color: #1AB393;
}

.pos_ab {
  position: absolute;
  right: 4px;
  top: 4px;
}

.checked_label_outer {
  display: flex;
  margin-bottom: 20px;
}

.checked_label_outer .ci_unvalid {
  color: #FF0000;
  font-size: 20px;
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userset.vue